<div>
  <div class="pt-2 command-title">{{'command.title.sweeperConfiguration' | transloco}}</div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-sweeper-enabled
        [params]="schema.commands['setSweeperEnabled']"
        [configuration]="configuration.commands['setSweeperEnabled']"
        [command]="'setSweeperEnabled'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-sweeper-enabled>
    </div>
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-sweeper-mode
        [params]="schema.commands['setSweeperMode']"
        [configuration]="configuration.commands['setSweeperMode']"
        [command]="'setSweeperMode'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-sweeper-mode>
    </div>
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-sweeper-speed
        [params]="schema.commands['setSweeperSpeed']"
        [configuration]="configuration.commands['setSweeperSpeed']"
        [command]="'setSweeperSpeed'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-sweeper-speed>
    </div>
  </div>

  <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
  <div class="pt-4 command-title">{{'command.title.wasteConfiguration' | transloco}}</div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-waste-enabled
        [params]="schema.commands['setWasteEnabled']"
        [configuration]="configuration.commands['setWasteEnabled']"
        [command]="'setWasteEnabled'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-waste-enabled>
    </div>
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-waste-limit
        [params]="schema.commands['setWasteLimit']"
        [configuration]="configuration.commands['setWasteLimit']"
        [command]="'setWasteLimit'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-waste-limit>
    </div>
  </div>
  <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
</div>

<div class="pt-4 command-title">{{'command.title.machineConfiguration' | transloco}}</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-6">
    <iot-zmxconnect-0262-v1-set-language
      [params]="schema.commands['setLanguage']"
      [configuration]="configuration.commands['setLanguage']"
      [command]="'setLanguage'" (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-set-language>
  </div>
  <div class="col-12 md:col-12 lg:col-6">
    <iot-zmxconnect-0262-v1-set-fruits-pro
      [params]="schema.commands['setFruitsPro']"
      [configuration]="configuration.commands['setFruitsPro']"
      [command]="'setFruitsPro'" (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-set-fruits-pro>
  </div>
  <div class="col-12 md:col-12 lg:col-6">
    <iot-zmxconnect-0262-v1-set-lock-pro
      [params]="schema.commands['setLockPro']"
      [configuration]="configuration.commands['setLockPro']"
      [command]="'setLockPro'" (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-set-lock-pro>
  </div>
  <div class="col-12 md:col-12 lg:col-6">
    <iot-zmxconnect-0262-v1-set-sel-up-down-disc
      [params]="schema.commands['setSelUpDownDisc']"
      [configuration]="configuration.commands['setSelUpDownDisc']"
      [command]="'setSelUpDownDisc'"
      (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-set-sel-up-down-disc>
  </div>
  <div class="col-12 md:col-12 lg:col-6">
    <iot-zmxconnect-0262-v1-set-up-value
      [params]="schema.commands['setUpValue']"
      [configuration]="configuration.commands['setUpValue']"
      [command]="'setUpValue'" (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-set-up-value>
  </div>
  <div class="col-12 md:col-12 lg:col-6">
    <iot-zmxconnect-0262-v1-set-down-value-disc
      [params]="schema.commands['setDownValueDisc']"
      [configuration]="configuration.commands['setDownValueDisc']"
      [command]="'setDownValueDisc'"
      (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-set-down-value-disc>
  </div>
  <div class="col-12 md:col-12 lg:col-6">
    <iot-zmxconnect-0262-v1-set-cashless-mode-fruit-number
      [params]="schema.commands['setCashlessModeFruitNumber']"
      [configuration]="configuration.commands['setCashlessModeFruitNumber']"
      [command]="'setCashlessModeFruitNumber'" (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-set-cashless-mode-fruit-number>
  </div>
</div>

<div>
  <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
  <div class="pt-4 command-title">{{'command.title.credentialsConfiguration' | transloco}}</div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-pin-ct
        [params]="schema.commands['setPinCt']"
        [configuration]="configuration.commands['setPinCt']"
        [command]="'setPinCt'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-pin-ct>
    </div>
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-pin-master
        [params]="schema.commands['setPinMaster']"
        [configuration]="configuration.commands['setPinMaster']"
        [command]="'setPinMaster'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-pin-master>
    </div>
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-pin-user
        [params]="schema.commands['setPinUser']"
        [configuration]="configuration.commands['setPinUser']"
        [command]="'setPinUser'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-pin-user>
    </div>
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-pin-sat
        [params]="schema.commands['setPinSat']"
        [configuration]="configuration.commands['setPinSat']"
        [command]="'setPinSat'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-pin-sat>
    </div>
  </div>

  <hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
  <div class="pt-4 command-title">{{'command.title.iotConfiguration' | transloco}}</div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-iot-timeout
        [params]="schema.commands['setIotTimeout']"
        [configuration]="configuration.commands['setIotTimeout']"
        [command]="'setIotTimeout'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-iot-timeout>
    </div>
    <div class="col-12 md:col-12 lg:col-6">
      <iot-zmxconnect-0262-v1-set-iot-sel-control
        [params]="schema.commands['setIotSelControl']"
        [configuration]="configuration.commands['setIotSelControl']"
        [command]="'setIotSelControl'"
        (onExecute)="executeCommand.emit($event)"
      ></iot-zmxconnect-0262-v1-set-iot-sel-control>
    </div>
  </div>
</div>

<hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
<div class="pt-4 command-title mb-3">{{'command.title.iotCommands' | transloco}}</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-6 xl:col-3">
    <iot-zmxconnect-0262-v1-reboot
      [params]="schema.commands['reboot']"
      [configuration]="configuration.commands['reboot']"
      [command]="'reboot'"
      (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-reboot>
  </div>
</div>

<hr style="border-color: #eceeec; width: 65%;" class="mx-auto">
<div class="pt-3 command-title mb-3">{{'command.title.machineCommands' | transloco}}</div>
<div class="flex mb-3">
  <div class="mr-3">
    <iot-zmxconnect-0262-v1-machine-enable
      [params]="schema.commands['machineEnable']"
      [configuration]="configuration.commands['machineEnable']"
      [command]="'machineEnable'"
      (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-machine-enable>
  </div>
  <div class="mr-3">
    <iot-zmxconnect-0262-v1-machine-disable
      [params]="schema.commands['machineDisable']"
      [configuration]="configuration.commands['machineDisable']"
      [command]="'machineDisable'"
      (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-machine-disable>
  </div>
  <div class="mr-3">
    <iot-zmxconnect-0262-v1-machine-cpu-reset
      [params]="schema.commands['machineCpuReset']"
      [configuration]="configuration.commands['machineCpuReset']"
      [command]="'machineCpuReset'"
      (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-machine-cpu-reset>
  </div>
  <div class="mr-3">
    <iot-zmxconnect-0262-v1-machine-reset-partial-fruit-counter
      [params]="schema.commands['machineResetPartialFruitCounter']"
      [configuration]="configuration.commands['machineResetPartialFruitCounter']"
      [command]="'machineResetPartialFruitCounter'"
      (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-machine-reset-partial-fruit-counter>
  </div>
  <div class="mr-3">
    <iot-zmxconnect-0262-v1-machine-fruits-cashless-reset
      [params]="schema.commands['machineFruitsCashlessReset']"
      [configuration]="configuration.commands['machineFruitsCashlessReset']"
      [command]="'machineFruitsCashlessReset'"
      (onExecute)="executeCommand.emit($event)"
    ></iot-zmxconnect-0262-v1-machine-fruits-cashless-reset>
  </div>
</div>
